import React from "react";
import { useCurrentFrame, interpolate, spring, useVideoConfig } from "remotion";

interface SanskritVerseProps {
  text: string;
  transliteration?: string;
  startFrame: number;
  durationFrames: number;
  fontSize?: number;
  accentColor?: string;
}

export const SanskritVerse: React.FC<SanskritVerseProps> = ({
  text,
  transliteration,
  startFrame,
  durationFrames,
  fontSize = 48,
  accentColor = "#D4A843",
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Phase 1: Sanskrit text fades in (frames 0-40)
  const textProgress = spring({
    frame: frame - startFrame,
    fps,
    config: { damping: 30, stiffness: 80 },
  });

  // Phase 2: Transliteration appears below (frames 40-70)
  const translitProgress = transliteration
    ? spring({
        frame: frame - startFrame - 40,
        fps,
        config: { damping: 25, stiffness: 100 },
      })
    : 0;

  // Glow effect pulsing
  const glowIntensity = interpolate(
    Math.sin(((frame - startFrame) / 90) * Math.PI * 2),
    [-1, 1],
    [4, 12]
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 24,
        padding: "40px 60px",
      }}
    >
      {/* Decorative line above */}
      <div
        style={{
          width: interpolate(textProgress, [0, 1], [0, 120]),
          height: 2,
          backgroundColor: accentColor,
          opacity: textProgress * 0.6,
        }}
      />

      {/* Sanskrit verse text */}
      <div
        style={{
          opacity: textProgress,
          transform: `scale(${interpolate(textProgress, [0, 1], [0.95, 1])})`,
          fontSize,
          fontFamily: "'Playfair Display', serif",
          fontWeight: 500,
          color: "#FFFFFF",
          textAlign: "center",
          lineHeight: 1.6,
          letterSpacing: "0.02em",
          textShadow: `0 0 ${glowIntensity}px ${accentColor}40`,
          maxWidth: "85%",
        }}
      >
        {text}
      </div>

      {/* Transliteration */}
      {transliteration && (
        <div
          style={{
            opacity: translitProgress,
            transform: `translateY(${interpolate(translitProgress, [0, 1], [10, 0])}px)`,
            fontSize: fontSize * 0.6,
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 400,
            fontStyle: "italic",
            color: accentColor,
            textAlign: "center",
            letterSpacing: "0.04em",
          }}
        >
          {transliteration}
        </div>
      )}

      {/* Decorative line below */}
      <div
        style={{
          width: interpolate(textProgress, [0, 1], [0, 80]),
          height: 1,
          backgroundColor: accentColor,
          opacity: textProgress * 0.4,
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
